"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ExpansionButtonHolder = void 0;

var _Icon = _interopRequireDefault(require("../../elements/icons/Icon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ExpansionButtonHolder = _styledComponents["default"].div.withConfig({
  displayName: "ExpandButton__ExpansionButtonHolder",
  componentId: "sc-1et00w8-0"
})(["min-width:30px;"]);

exports.ExpansionButtonHolder = ExpansionButtonHolder;

var ExpandedButton = function ExpandedButton(_ref) {
  var expanded = _ref.expanded,
      onClick = _ref.onClick;
  return _react["default"].createElement(ExpansionButtonHolder, null, expanded ? _react["default"].createElement(_Icon["default"], {
    iconName: "fa-minus-circle",
    onClick: onClick
  }) : _react["default"].createElement(_Icon["default"], {
    iconName: "fa-plus-circle",
    onClick: onClick
  }));
};

ExpandedButton.propTypes = {
  expanded: _propTypes["default"].bool.isRequired,
  onClick: _propTypes["default"].func.isRequired
};
var _default = ExpandedButton;
exports["default"] = _default;